import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const CheckMark = ({ height = '11px', width = '14px', ...rest }) => {
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: '0 0 14 11', ...rest, children: _jsx("path", { d: 'M10.912-.034l2.175 2.067-7.91 8.326L.773 4.111l2.453-1.729L5.522 5.64z' }) }));
};
//# sourceMappingURL=CheckMark.js.map